export default __webpack_public_path__ + "static/media/thumbs_up.7f97a40a.png";